import { $api } from "@/services/api";
import store from "@/store";
import type { Applicant } from "@/models/application";

export default function useApplication() {
  async function createConciergeAsync() {
    const index = store.state?.appData?.applicants.length - 1;

    const applicantId = store.state?.appData?.applicants[index].id;

    const person = store.state?.appData?.applicants.find((a: Applicant) => a.id === applicantId);

    if (person) {
      $api.person.createConcierge(person.id, {
        applicantId: person.id,
        conciergeConsent: false,
      });
    }
  }

  async function getLenderConfigurationByAppId(
    appId: number,
    lenderId?: number | undefined,
    productTypeId?: number | undefined,
    programTypeId?: number | undefined,
    flowType?: number | null,
  ) {
    let response = {} as any;
    let lenderConfig = {} as any;

    // If programTypeId has been set - supports refi case
    if (lenderId && productTypeId && programTypeId) {
      lenderConfig = await $api.configuration.getLenderConfiguration(lenderId, programTypeId, productTypeId);
      store.dispatch("setLenderData", lenderConfig);
      return lenderConfig;
    } else {
      // Handle default case
      response = await $api.applications.getApplication(appId, flowType);
      if (response && response?.application) {
        if (response?.application?.programTypeId) {
          lenderConfig = await $api.configuration.getLenderConfiguration(
            response?.application?.lenderId,
            response?.application?.programTypeId,
            response?.application?.productTypeId,
          );
        } else {
          lenderConfig = await $api.configuration.getLenderConfigurationByLenderId(response?.application?.lenderId);
        }

        store.dispatch("setLenderData", lenderConfig);
        return lenderConfig;
      } else {
        return [];
      }
    }
  }

  async function getLenderConfigurationAsync(request: {
    appId: number;
    lenderId?: number | undefined;
    productTypeId?: number | undefined;
    programTypeId?: number | undefined;
    flowType?: number | null;
  }) {
    let response = {} as any;
    let lenderConfig = {} as any;
    const { appId, lenderId, productTypeId, programTypeId, flowType } = request;

    // If programTypeId has been set - supports refi case
    if (lenderId && productTypeId && programTypeId) {
      lenderConfig = await $api.configuration.getLenderConfiguration(lenderId, programTypeId, productTypeId);
      store.dispatch("setLenderData", lenderConfig);
      return lenderConfig;
    } else {
      // Handle default case
      response = await $api.applications.getApplication(appId, flowType);
      if (response && response?.application) {
        if (response?.application?.programTypeId) {
          lenderConfig = await $api.configuration.getLenderConfiguration(
            response?.application?.lenderId,
            response?.application?.programTypeId,
            response?.application?.productTypeId,
          );
        } else {
          lenderConfig = await $api.configuration.getLenderConfigurationByLenderId(response?.application?.lenderId);
        }

        store.dispatch("setLenderData", lenderConfig);
        return lenderConfig;
      } else {
        return [];
      }
    }
  }
  return {
    getLenderConfigurationByAppId,
    getLenderConfigurationAsync,
    createConciergeAsync,
  };
}
